import { render, staticRenderFns } from "./best-history-table-row.component.vue?vue&type=template&id=643146db&scoped=true"
import script from "./best-history-table-row.component.vue?vue&type=script&lang=js"
export * from "./best-history-table-row.component.vue?vue&type=script&lang=js"
import style0 from "./best-history-table-row.component.vue?vue&type=style&index=0&id=643146db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643146db",
  null
  
)

export default component.exports